// import { decryptData, encryptData } from "../utils/crypto";

// const API_URL = `${process.env.REACT_APP_API_BASE_URL}`;

// // Helper to handle response parsing and decryption
// const handleResponse = async (response) => {
//     if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         localStorage.removeItem("user");
//         window.location.href = "/admin";
//         return null;
//     }
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.message || 'Network response was not ok');
//     }
//     const data = await response.json();

//     // Auto Decrypt Response
//     if (data && data.payload) {
//         return decryptData(data.payload);
//     }
//     return data;
// };

// // Common Headers
// const getHeaders = (isMultipart = false) => {
//     const headers = {
//         'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
//     };
//     if (!isMultipart) {
//         headers['Content-Type'] = 'application/json';
//         headers['Accept'] = 'application/json';
//     }
//     return headers;
// };

// export const GET = async (endpoint) => {
//     const response = await fetch(`${API_URL}${endpoint}`, {
//         method: 'GET',
//         headers: getHeaders(),
//     });
//     return handleResponse(response);
// }

// export const POST = async (endpoint, data) => {
//     const payload = { payload: encryptData(data) };

//     const response = await fetch(`${API_URL}${endpoint}`, {
//         method: 'POST',
//         headers: getHeaders(),
//         body: JSON.stringify(payload),
//     });
//     return handleResponse(response);
// }

// export const PUT = async (endpoint, data) => {
//     const payload = { payload: encryptData(data) };

//     const response = await fetch(`${API_URL}${endpoint}`, {
//         method: 'PUT',
//         headers: getHeaders(),
//         body: JSON.stringify(payload),
//     });
//     return handleResponse(response);
// }

// export const DELETE = async (endpoint) => {
//     const response = await fetch(`${API_URL}${endpoint}`, {
//         method: 'DELETE',
//         headers: getHeaders(),
//     });
//     return handleResponse(response);
// }

// // For File Uploads (Multipart)
// export const FORM_POST = async (endpoint, data, method = 'POST') => {
//     let formData;
//     if (data instanceof FormData) {
//         formData = data;
//     } else {
//         formData = new FormData();
//         const dataToEncrypt = {};
//         for (const key in data) {
//             const value = data[key];
//             if (value instanceof File || value instanceof Blob) {
//                 formData.append(key, value);
//             } else {
//                 dataToEncrypt[key] = value;
//             }
//         }
//         if (Object.keys(dataToEncrypt).length > 0) {
//             formData.append('payload', encryptData(dataToEncrypt));
//         }
//     }
//     const response = await fetch(`${API_URL}${endpoint}`, {
//         method,
//         headers: getHeaders(true),
//         body: formData,
//     });
//     return handleResponse(response);
// }

const API_URL = `${process.env.REACT_APP_API_BASE_URL}`;

// Helper to handle response parsing
const handleResponse = async (response) => {
    if (response.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        window.location.href = "/admin";
        return null;
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.message || errorData.error || "Network response was not ok";
        throw new Error(errorMessage);
    }

    // An unknown path falls through the backend's SPA catch-all and comes back as
    // index.html, so a bare response.json() here reports "Unexpected token '<'"
    // and hides the real cause: this build is pointed at an API that has no such
    // endpoint (usually a frontend deployed ahead of the backend).
    const body = await response.text();
    try {
        return JSON.parse(body);
    } catch (err) {
        if (body.trim().startsWith("<")) {
            throw new Error(
                `This endpoint is not available on the API this app is pointed at (${API_URL}). ` +
                `Deploy the backend, or point REACT_APP_API_BASE_URL at one that has it.`
            );
        }
        throw new Error("The server returned a response this app could not read.");
    }
};

// Common Headers
const getHeaders = (isMultipart = false) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    };

    if (!isMultipart) {
        headers["Content-Type"] = "application/json";
        headers["Accept"] = "application/json";
    }

    return headers;
};

export const GET = async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: "GET",
        headers: getHeaders(),
    });
    return handleResponse(response);
};

export const POST = async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return handleResponse(response);
};

export const PUT = async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    return handleResponse(response);
};

export const PATCH = async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: "PATCH",
        headers: getHeaders(),
        body: JSON.stringify(data || {}),
    });
    return handleResponse(response);
};

export const DELETE = async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: "DELETE",
        headers: getHeaders(),
    });
    return handleResponse(response);
};

// For File Uploads (Multipart)
export const FORM_POST = async (endpoint, data, method = "POST") => {
    let formData;

    if (data instanceof FormData) {
        formData = data;
    } else {
        formData = new FormData();
        for (const key in data) {
            formData.append(key, data[key]);
        }
    }

    const response = await fetch(`${API_URL}${endpoint}`, {
        method,
        headers: getHeaders(true), // no content-type for multipart
        body: formData,
    });

    return handleResponse(response);
};
